import {ReactNode, Fragment, useCallback} from 'react';
import Div100vh from 'react-div-100vh';

import {LanguageSwitcher, Copyright, ProfileMenu} from 'components';

import {Logo} from './Logo';

type Props = {
    children: ReactNode;
    hasLogo?: boolean;
    hasTranslate?: boolean;
    hasRestrictedProfileMenu?: boolean;
    hasFooter?: boolean;
    vh100?: boolean;
};

export const BaseLayout: React.FC<Props> = ({children, hasLogo, hasTranslate, hasRestrictedProfileMenu, hasFooter, vh100 = true}) => {
    const renderHeader = useCallback(() => (
        <Fragment>
            {hasLogo && <Logo />}
            {hasTranslate && <LanguageSwitcher className='tw-w-40 tw-absolute tw-top-3 tw-right-3' />}
            {hasRestrictedProfileMenu && !hasTranslate &&
                <div className='tw-absolute tw-top-6 tw-right-6'>
                    <ProfileMenu
                        items={{
                            profile: true,
                            language: true,
                            logout: true
                        }}
                        isAvailable
                        notificationsEnabled={false}
                    />
                </div>}
        </Fragment>
    ), [hasLogo, hasRestrictedProfileMenu, hasTranslate]);

    const renderFooter = useCallback(() => (
        hasFooter ?
            <div className='tw-absolute tw-bottom-3 tw-left-3 tw-text-default-dimmed'>
                <Copyright />
            </div> : null
    ), [hasFooter]);

    const renderContent = useCallback(() => (
        <Fragment>
            {renderHeader()}
            {children}
            {renderFooter()}
        </Fragment>
    ), [renderHeader, children, renderFooter]);

    return vh100 ? (
        <Div100vh>
            {renderContent()}
        </Div100vh>
    ) : renderContent();
};
